import classes from './Carousel.module.scss';

const Carousel = ({ cards, activeIndex, prevIndex, total, onSlideClick, isAnimating }) => {
    return (
        <>
            <img
                src={cards[prevIndex].bg}
                alt=""
                className={classes.activeBg}
            />
            {cards.map((item, index) => {
                const position = (index - activeIndex + total) % total;
                return (
                    <div
                        key={item.bg}
                        className={`
                            ${classes.image} 
                        ${classes[`image_0${position + 1}`]}
                        ${((position === 3) && (activeIndex !== prevIndex)) ? classes.changing : ''}
                        ${isAnimating ? classes.disabled : ''}
                        `}
                        onClick={() => onSlideClick(index)}
                    >
                        <img
                            className={classes.img}
                            src={item.bg}
                            alt=""
                        />
                    </div>
                );
            })}
            <div className={classes.pagination}>
                {cards.map((_, index) =>
                    <span className={`${classes.bullet} ${activeIndex === index ? classes.active : ''}`} key={index}></span>
                )}
            </div>
        </>
    );
};

export default Carousel;
